
  import {Component, Vue, Inject, Prop, Watch, Ref} from "vue-property-decorator";
import api from "@/api";
  import {ElForm} from "element-ui/types/form";
  import {AuditFlowDto} from "@/api/appService";

@Component
export default class RefundDialog extends Vue {
  @Ref() readonly dataForm!: ElForm;


  defaultValue: number | undefined = 0;
  row: any = {};
  show = false;
  isLoaded = false;

  private refundForm = {
    refundValue:0,
    desc:'',
    auditFlowId:''
  };

  auditFlowList:AuditFlowDto[] = [];

  created(){
    api.auditFlow.getAll({maxResultCount:65535}).then(res=>{
      this.auditFlowList = res.items??[];
    });
  }

  @Watch("show")
  onShowChange(val: boolean) {
    if (val) {
      this.isLoaded = true;
      this.refundForm.refundValue = this.defaultValue!;
    } else {
      this.isLoaded = false;
      this.refundForm.refundValue = 0;
      this.refundForm.desc = '';
      this.refundForm.auditFlowId = '';
      this.$nextTick(()=>{
        (this.$refs.dataForm as any).clearValidate();
      });

    }
  }

  handleSubmit() {
     (this.$refs.dataForm as any).validate((result:boolean)=>{
      if(result){
        this.onValidateSuccess();
      }
    });




  }

  onValidateSuccess(){
    if (!this.defaultValue) {
      this.$message.error("实际支付金额有误");
      return;
    }


    if (this.refundForm.refundValue > this.defaultValue!) {
      this.$message.error("退款金额不能大于实际支付金额");
      this.refundForm.refundValue = this.defaultValue!;
    } else {
      this.$confirm("你确定发起退款吗?", "提示").then(() => {
        this.show = false;
        this.$emit("submit", {
          row: this.row,
          desc: this.refundForm.desc,
          refundValue: this.refundForm.refundValue,
          auditFlowId: this.refundForm.auditFlowId
        });
      });
    }
  }

  closeOnClickModal() {}

  refundInputRules = {
    refundValue:[
      {required:true,message:'退款金额是必须的',trigger:['change','blur']},
      {
        type:'number',
        message:'退款金额必须大于或等于0.01',
        trigger:['change','blur'],
        validator:(rule:any,value:number,callback:Function)=>{
          if(value>=0.01){
            callback();
          } else {
            callback(new Error('退款金额必须大于或等于0.01'))
          }
        }},
    ],
    auditFlowId:[
      {required:true,message:'请选择审核流程',trigger:['change','blur']}
    ],
    desc:[
      {required:true,type:'string',message:'退款原因是必须的',trigger:['change','blur']}
    ]
  }
}
